export const MobilePhoneRegex = /^(?:0|98|\+98|\+980|0098|098|00980)?(9\d{9})$/;
